
import { defineComponent, inject, reactive, ref } from "vue";

import type { FormInstance, FormRules, Action  } from "element-plus";
import { ElMessageBox } from 'element-plus'

import acrdService from "@/core/services/AcrdService";
import { errManager } from "@/core/config/Tools";

export default defineComponent({
  name: "kt-explore",
  setup() {

    const gblRowAcrd = <any> inject('gblRowAcrd')
    const loading = ref(false)

    const formChangeRef = ref < FormInstance > ()
    const formChange = reactive({
        idacrd: "",
        checkdoc: "4",
        message: ""
    })
    const rules = reactive < FormRules > ({
        checkdoc: [{
            required: true,
            message: "campo requerido",
            trigger: ["blur", "change"],
        }, ],
        message: [{
            required: true,
            message: "campo requerido",
            trigger: ["blur", "change"],
        }, ],
    })

    const submitForm = async (formEl: FormInstance | undefined) => {
        if (!formEl) return;
        await formEl.validate((valid, fields) => {
            if (valid)
                saveForm()
                    
        });
    };

    const resetForm = (formEl: FormInstance | undefined) => {
        if (!formEl) return;
        formEl.resetFields();
    };

    const saveForm = async () => {
            loading.value = true
            formChange.idacrd = gblRowAcrd.value.idacreditation
            await acrdService.changeStatus('acreditation', formChange)
            .then( (res) => {
                loading.value = false
                if(res.data.status){
                     ElMessageBox.alert(res.data.message, 'SISDEU', {
                        confirmButtonText: 'OK',
                        callback: (action: Action) => {
                            resetForm(formChangeRef.value)
                        },
                    })
                }
            }).catch( ({response}) => {
                loading.value = false
                errManager(response)
            })
    }

    return {
      gblRowAcrd,
      loading,
      formChangeRef,
      formChange,
      rules,
      submitForm
    };
  },
});
